'use strict';

angular.module('amexReconciliationApp')
  .service('ApproveAllTransactionsRepository', function ($http,
                                                         TransactionTabFilterModel,
                                                         TransactionsModel,
                                                         TransactionSearchModel) {
    var self = this;

    var url = function () {
      if(TransactionSearchModel.isBcaManager()) {
        return '/api/v1/transactions/approveAllByBcaManager';
      } else if(TransactionSearchModel.isCardManager()) {
        return '/api/v1/transactions/approveAllByCardManager';
      } else if(TransactionSearchModel.isAccountingManager()) {
        return '/api/v1/transactions/approveAllByAccountingManager';
      }
      return '';
    };

    self.approveAllTransactions = function () {
      return $http({
        url: url(),
        method: 'PATCH',
        params: TransactionSearchModel.queryParams()
      });
    };

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/ApproveAllTransactionsRepository.js
// module id = 601
// module chunks = 0